import { createStore, applyMiddleware } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { createBrowserHistory } from "history";

import thunk from "redux-thunk";
import apiMiddleware from "./api.middleware";
// import reduxLogger from "redux-logger";
import createRootReducer from "./reducers";
import { compose } from "redux";

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL || "/",
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["authReducer", "newinvestor"],
};

const isDevEnv = process.env.NODE_ENV == "development";
const composeEnhancers =
  (isDevEnv &&
    typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const persistedReducer = persistReducer(
  persistConfig,
  createRootReducer // root reducer with router state
);

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk, apiMiddleware))
);

export const persistor = persistStore(store);
export default store;
